module.exports = __webpack_public_path__ + "static/media/norutec_20_28.4c3c259f.png";